import { CommandListContracts } from "./commands/cmdListContracts";
import { CommandListContractVersions } from "./commands/cmdListContractVersions";
import { CommandGetContract } from "./commands/cmdGetContract";
import { CommandCreateContract, CreateContractPayload } from "./commands/cmdCreateContract";
import { CommandUpdateContract, UpdateContractPayload } from "./commands/cmdUpdateContract";
import { CommandDeleteContract } from "./commands/cmdDeleteContract";
import { Contract } from "@models/contract.model";

export class ContractService {
  async list(params?: {
    client_org_id?: number;
    service_provider_org_id?: number;
    engagement_id?: number;
    is_active?: boolean;
  }): Promise<Contract[]> {
    try {
      const cmd = new CommandListContracts();
      return await cmd.run(params);
    } catch (error) {
      console.error("Failed to fetch contracts:", error);
      return [];
    }
  }

  async get(contractId: number): Promise<Contract | null> {
    try {
      const cmd = new CommandGetContract();
      return await cmd.run(contractId);
    } catch (error) {
      console.error(`Failed to fetch contract ${contractId}:`, error);
      return null;
    }
  }

  async create(payload: CreateContractPayload): Promise<Contract> {
    try {
      const cmd = new CommandCreateContract();
      return await cmd.run(payload);
    } catch (error) {
      console.error("Failed to create contract:", error);
      throw error;
    }
  }

  async update(contractId: number, payload: UpdateContractPayload): Promise<Contract> {
    try {
      const cmd = new CommandUpdateContract();
      return await cmd.run(contractId, payload);
    } catch (error) {
      console.error(`Failed to update contract ${contractId}:`, error);
      throw error;
    }
  }

  async delete(contractId: number): Promise<Contract> {
    try {
      const cmd = new CommandDeleteContract();
      return await cmd.run(contractId);
    } catch (error) {
      console.error(`Failed to delete contract ${contractId}:`, error);
      throw error;
    }
  }

  /** Term history (MPN-1336). Errors propagate: a silent [] would read as "nothing ever
   *  changed", which is the one wrong answer during a billing dispute. */
  async listVersions(contractId: number) {
    return new CommandListContractVersions().run(contractId);
  }
}